import { QuoteForm } from './QuoteForm';
export { getRatingInputsFromSubmission } from './QuoteForm';
export type { QuoteValues } from './QuoteForm';

export default QuoteForm;
